module.exports = __webpack_public_path__ + "img/login_banner.f77b1864.png";